import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectGlobalCounter } from './selectors';

import CounterText from './CounterText';

export class GlobalCounter extends React.PureComponent {
  static propTypes = {
    counter: PropTypes.number.isRequired,
  };

  render() {
    return (
      <CounterText>
        Всего символов: {this.props.counter}
      </CounterText>
    );
  }
}

export const mapStateToProps = createStructuredSelector({
  counter: selectGlobalCounter(),
});

export default connect(mapStateToProps)(GlobalCounter);
